import React, { Children, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { useLpStore } from "../../../store/useLiquidityPartner";
import AppSelectInput from "../../base-components/AppSelectInput";
import { LuCopyCheck, LuCopyPlus } from "react-icons/lu";
import _ from "lodash";
interface ModalProps {
  // title: string;
  // subtitle: string;
  isOpen: boolean;
  onClose: (arg: boolean) => void;
}
const LPWalletModal: React.FC<ModalProps> = ({
  // title,
  isOpen,
  onClose,
  // subtitle,
}) => {
  const { walletAddress, walletType, blockchain } = useLpStore(
    (state) => state.lpWallet
  );
  const { name } = useLpStore((state) => state.Lp);
  const overLayRef = React.useRef(null);
  const setLpActive = useLpStore((state) => state.setActiveLp);
  const activeLp = useLpStore((state) => state.activeLp);
  const [copy, setCopy] = useState("");

  const handleOverLayClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (e.target === overLayRef.current) {
      onClose(false);
    }
  };
  const toggleLp = () => {
    if (activeLp === false) {
      setLpActive(true);
    } else {
      setLpActive(false);
    }

    onClose(false);
  };
  const copyToClipBoard = (token: string) => {
    navigator.clipboard.writeText(token);
    setCopy(token);
    let timeout = setTimeout(() => {
      setCopy("");
      clearTimeout(timeout);
    }, 1500);
  };

  return (
    <>
      {isOpen ? (
        <div className="modal  fixed w-full h-full top-0 left-0 justify-center items-center transition-opacity duration-300 z-50">
          <div
            ref={overLayRef}
            className="modal_overlay absolute top-0 right-0 flex justify-end w-full h-full cursor-pointer bg-[#13111173]"
            onClick={handleOverLayClick}
          >
            <div className="modal_box relative bg-[#fff] h-full w-[400px] right-0 rounded-l-lg">
              <div className="flex items-center justify-between">
                <div
                  onClick={() => onClose(false)}
                  className=" flex items-center justify-center rounded-sm
                hover:bg-slate-200 px-2 hover:rounded-sm hover:text-center ml-3"
                >
                  <span className=" hover:transform  transition duration-150 ease-in-out underline hover:text-[#0eb683]">
                    Edit
                  </span>
                </div>
                <div
                  onClick={() => onClose(false)}
                  className=" flex items-center justify-center rounded-full
                hover:bg-slate-200 p-3 hover:rounded-full hover:text-center "
                >
                  <span className="hover:rotate-90 hover:transform  transition duration-150 ease-in-out">
                    <IoMdClose size={29} className="" />
                  </span>
                </div>
              </div>
              <div className="title pt-16  px-5">
                <h1 className="text-3xl  text-[#071827]"> {name}</h1>
              </div>
              <div className="modal_content px-5">
                <p className="d text-xl  text-[#5C6F7F]">
                  {_.capitalize(blockchain)}
                </p>
                {/* <p className="text-[#071827] text-sm mt-3">
                  Last transaction - <span>{}</span>{" "}
                </p> */}
              </div>
              <div className="Lp-container px-5 mt-10">
                <div className="flex items-center justify-between">
                  <p className="text-[#5C6F7F] text-xs">Token Type :</p>
                  <p className=" text-[#071827]  text-sm">{walletType}</p>
                </div>
                <div className="flex items-center justify-between mt-5 ">
                  <p className="text-[#5C6F7F]  text-xs">Blockchain Name : </p>
                  <p className=" text-[#071827]  text-sm">{blockchain}</p>
                </div>
                <div className="flex items-center justify-between mt-5 ">
                  <p className="text-[#5C6F7F]  text-xs">Wallet Address : </p>
                  <div className="flex items-center gap-1">
                    <span
                      onClick={() => copyToClipBoard(walletAddress)}
                      className="text-sm cursor-pointer "
                    >
                      {copy ? (
                        <span className="text-[#0eb683]">
                          <LuCopyCheck />
                        </span>
                      ) : (
                        <LuCopyPlus />
                      )}
                    </span>
                    <p className=" text-[#071827] truncate w-40  text-sm">
                      {walletAddress}
                    </p>
                  </div>
                </div>
              </div>
              <div className="w-full px-5 mt-5 absolute bottom-14">
                <div className="w-full  ">
                  <button
                    onClick={toggleLp}
                    className="text-[#fff] border border-[#0eb683] bg-[#0eb683] w-full py-3 rounded-md active:bg-[#56f6d4] active:scale-90 transition-all"
                  >
                    {/* Edit wallet address */}
                    {activeLp
                      ? "Deactivate for stablecoin transaction"
                      : "Activate for stablecoin transactions"}
                  </button>
                  <button className="bg-[#fff] border border-[#0eb683]  text-[#0eb683] w-full py-3 rounded-md mt-5 hover:bg-[#e10] hover:border-[#e10] hover:text-[#fff] active:scale-90 transition-all">
                    Delete wallet address
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default LPWalletModal;
